import {
  SET_USER_DATA,
  CLEAR_USER_DATA,
  UPDATE_USER_DATA,
  SET_USER_LOADING,
} from '../actions/User';

const initialState = {
  user: null,
  isAuthenticated: false,
  isLoading: false,
  lastUpdated: null,
};

const User = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_DATA:
      return {
        ...state,
        user: action.payload,
        isAuthenticated: !!action.payload,
        isLoading: false,
        lastUpdated: Date.now(),
      };

    case UPDATE_USER_DATA:
      return {
        ...state,
        user: {...state.user, ...action.payload},
        lastUpdated: Date.now(),
      };

    case CLEAR_USER_DATA:
      return {
        ...state,
        user: null,
        isAuthenticated: false,
        isLoading: false,
        lastUpdated: null,
      };

    case SET_USER_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    default:
      return state;
  }
};

export default User;
